var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.88,
    height: 7.001,
    viewBox: "0 0 11.88 7.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.228,9.308l4.125,4.125,4.125-4.125a1.06,1.06,0,1,1,1.5,1.5l-4.88,4.88a1.059,1.059,0,0,1-1.5,0l-4.88-4.88a1.059,1.059,0,0,1,0-1.5A1.082,1.082,0,0,1,8.228,9.308Z",
    transform: "translate(-6.407 -8.997)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.4cd71905.svg";
export { ForwardRef as ReactComponent };